import { render } from "./swiper.vue?vue&type=template&id=6425588c&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"

import "./swiper.vue?vue&type=style&index=0&id=6425588c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6425588c"]])

export default __exports__